export default class ViewBox {
	#height: number;
	#width: number;
	#x: number;
	#y: number;
	/**
	 * The viewBox attribute defines the position and dimension, in user space, of an SVG viewport.
	 *
	 * @param x The x coordinate
	 * @param y The y coordinate
	 * @param width The width in pixels, minimum 1px
	 * @param height The height in pixels, minimum 1px
	 * @see {@link https://developer.mozilla.org/en-US/docs/Web/SVG/Reference/Attribute/viewBox} for syntax
	 */
	public constructor(x: number, y: number, width: number, height: number) {
		assertIsNumber(x);
		this.#x = x;
		assertIsNumber(y);
		this.#y = y;
		assertIsPositiveOneOrMore(width);
		this.#width = width;
		assertIsPositiveOneOrMore(height);
		this.#height = height;
	}

	public toViewBoxString(): string {
		return `${this.#x} ${this.#y} ${this.#width} ${this.#height}`;
	}
}

function assertIsNumber(value: unknown): asserts value is number {
	if (typeof value === 'number') {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be of type number`);
}

function assertIsPositiveOneOrMore(value: unknown): asserts value is number {
	if (typeof value === 'number' && value >= 1) {
		return;
	}
	throw new RangeError(`[${String(value)}] is invalid, must be value of 1 or above`);
}
